/**
 * 待办箱前端适配 — 数据由服务端 yn_todo_list 按职务统一计算
 * 矩阵见 yn_todo.php 文件头注释
 */
import api from '@/utils/api'

const NODE_BY_XMZT = {
  new: '委托下单',
  draft: '委托下单',
  pending: '采样任务管理',
  pending_audit: '委托审核',
  audit_pass: '周期任务安排',
  plan_ready: '周期任务安排',
  dispatched: '采样任务管理',
  sampling: '采样任务管理',
  doing: '采样任务管理',
  handover: '样品管理',
  lab_ready: '检测任务安排',
  labing: '实验室分析',
  lab_done: '报告编写',
  reporting: '报告管理',
  done: '已完成'
}

function routeForProject(p) {
  const zt = (p && p.xmzt) || ''
  const xmbh = (p && p.xmbh) || ''
  const enc = encodeURIComponent(xmbh)
  if (zt === 'handover') return xmbh ? `/soil/handover?xmbh=${enc}` : '/soil/handover'
  if (zt === 'lab_ready') return xmbh ? `/soil/arrange?xmbh=${enc}` : '/soil/arrange'
  if (zt === 'labing' || zt === 'lab_done') return '/soil/lab-queue'
  if (zt === 'reporting' || zt === 'done') return '/reports'
  if (['dispatched', 'sampling', 'doing', 'pending'].includes(zt)) return '/pick/batch-contract'
  if (zt === 'pending_audit') return xmbh ? `/routine/audit/${enc}` : '/todo'
  return (p && p.route) || '/todo'
}

function nodeNameFor(p) {
  if (!p) return '待处理'
  if (p.nodeName) return p.nodeName
  return NODE_BY_XMZT[p.xmzt] || '待处理'
}

function normalizeRow(r) {
  const row = r || {}
  return {
    id: row.id || row.xmbh || String(Math.random()),
    caseName: row.caseName || row.xmmc || row.xmbh || '未命名项目',
    xmbh: row.xmbh || '',
    nodeName: row.nodeName || nodeNameFor(row),
    relatedForms: row.relatedForms || '',
    prevUser: row.prevUser || '—',
    receiveDate: row.receiveDate || '',
    creater: row.creater || '—',
    createDate: row.createDate || row.receiveDate || '',
    unread: !!row.unread,
    route: row.route || routeForProject(row),
    groupKey: row.groupKey || '更早以前',
    xmzt: row.xmzt || '',
    taskId: row.taskId || '',
    raw: row
  }
}

/** 把扁平行按 groupKey 分组（接口只给 items 时的兜底） */
function groupFromItems(items) {
  const order = ['今天', '昨天', '更早以前']
  const map = {}
  items.forEach(r => {
    const k = r.groupKey || '更早以前'
    if (!map[k]) map[k] = []
    map[k].push(r)
  })
  return order
    .filter(k => map[k] && map[k].length)
    .map(k => ({ key: k, expand: true, items: map[k] }))
}

function parseTodoPayload(res) {
  let d = res && res.data
  if (typeof d === 'string') {
    try {
      d = JSON.parse(d.trim())
    } catch (e) {
      const i = d.indexOf('{')
      if (i >= 0) {
        try {
          d = JSON.parse(d.slice(i))
        } catch (e2) {
          d = {}
        }
      } else {
        d = {}
      }
    }
  }
  d = d || {}
  if (d.error) throw new Error(d.error)

  let groups = Array.isArray(d.groups) ? d.groups : []
  groups = groups
    .map(g => ({
      key: (g && g.key) || '更早以前',
      expand: !g || g.expand !== false,
      items: ((g && g.items) || []).map(normalizeRow)
    }))
    .filter(g => g.items.length)

  if (!groups.length) {
    const items = Array.isArray(d.items) ? d.items.map(normalizeRow) : []
    if (items.length) groups = groupFromItems(items)
  }
  return groups
}

/**
 * 分组待办（待办箱）
 */
export async function fetchTodoRows() {
  const res = await api.get('yn_todo_list')
  return parseTodoPayload(res)
}

/**
 * 扁平行（首页角标 / 待办日历）
 */
export async function fetchTodoFlatRows() {
  const res = await api.get('yn_todo_list')
  const groups = parseTodoPayload(res)
  const rows = []
  groups.forEach(g => {
    ;(g.items || []).forEach(r => rows.push(r))
  })
  return rows
}

export { NODE_BY_XMZT, routeForProject, nodeNameFor }
